module.exports = __webpack_public_path__ + "img/weather_bg1.72108e22.png";